"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _getAppConfig = _interopRequireDefault(require("../../constants/getAppConfig"));
const withAppConfig = Component => props => /*#__PURE__*/_react.default.createElement(Component, Object.assign({
  appConfig: (0, _getAppConfig.default)()
}, props));
var _default = exports.default = withAppConfig;